import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext } from 'react';
import classNames from 'classnames';

export default function usePagination(page, setPage, totalPages) {
  const { pagination } = useContext(GlobalContext);

  const paginationControls = {
    next() {
      const currentPage = page + 1 > totalPages ? page : page + 1;
      setPage(currentPage);
    },
    prev() {
      const currentPage = page - 1 < pagination.minPage ? page : page - 1;
      setPage(currentPage);
    },
    goTo(target) {
      target = target < pagination.minPage ? pagination.minPage : target;
      const currentPage = target > totalPages ? totalPages : target;
      setPage(currentPage);
    },
    calculateMaxVisibleButtons() {
      //get amount of buttons for each side
      let maxLeft = page - Math.floor(pagination.maxButtons / 2);
      let maxRight = page + Math.floor(pagination.maxButtons / 2);

      //If first page keep left and right buttons on min and max
      if (maxLeft < 1) {
        maxLeft = 1;
        maxRight = pagination.maxButtons;
      }

      //If amount right pass through totalPages
      if (maxRight > totalPages) {
        //Remove middle button and verify if has only one page
        maxLeft =
          totalPages - (pagination.maxButtons - 1) < 1
            ? 1
            : totalPages - (pagination.maxButtons - 1);
        //Keep right buttons on max possible
        maxRight = totalPages;
      }

      return { maxLeft, maxRight };
    },
    createButtons() {
      const { maxLeft, maxRight } = paginationControls.calculateMaxVisibleButtons();
      const buttons = [];
      for (let currentPage = maxLeft; currentPage <= maxRight; currentPage++) {
        const active = page === currentPage;
        const pageButtonClass = classNames({
          pagination__button: true,
          'pagination__button--active': active,
        });

        const button = (
          <button
            key={currentPage}
            className={pageButtonClass}
            onClick={() => paginationControls.goTo(currentPage)}
          >
            {currentPage}
          </button>
        );
        buttons.push(button);
      }
      return buttons;
    },
  };

  return { pagination, paginationControls };
}
